import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { IActionButtonProps } from 'src/components/common/types/buttonTypes';
const ActionButton = ({
	title,
	enabled,
	onClick,
	enabledColor,
	disabledColor,
	children,
}: IActionButtonProps): JSX.Element => {
	const button = (
		<IconButton
			disabled={!enabled}
			onClick={enabled ? onClick : undefined}
			sx={{ color: enabled ? enabledColor : disabledColor }}
		>
			{children}
		</IconButton>
	);

	return (
		<Tooltip title={title} placement='bottom'>
			{enabled ? button : <span>{button}</span>}
		</Tooltip>
	);
};

export default ActionButton;
